import '@components/module-components/POSMap/pos-map.scss';
import {createSearchQuery, getParams, getQueryParams, translate} from '@src/helpers';

import {ENV} from "@environments/environment";
import VerificationLegendBadge from "@components/VerificationLegend/VerificationLegendBadge";
import {I_POS, ProcessData, ProcessStatusMap} from "@components/module-components/POSMap/types";
import VerifiedLabelMarkup from "@components/module-components/POSMap/helper/VerifiedLabelMarkup";
import {setPreviousUrl} from "@redux/actions/navigatorAction";

import React, {Fragment, useCallback, useState, useEffect, useMemo} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux";

const {AWS_S3_FILE_UPLOAD, API_URL, GG_KEY, URL_WEBAPP} = ENV


const ContentMarkerMultiple = ({poz}: I_POS) => {
  const langData = useSelector((state: any) => state.currentLanguage) as any;

  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  const {imgSource, imgAlt} = ProcessStatusMap[poz.claimed_status] || {};

  const onClickProcessV2 = useCallback((process: ProcessData): void => {
    try {

      if (!process.b2c_url) return;
      const {brand} = getParams();
      const qs = createSearchQuery({...getQueryParams(process.b2c_url), brand});

      dispatch(setPreviousUrl({
        previous: {...location},
        query: {
          viewMode: "mapView",
          process_position: process.custom_order,
        }
      }));

      history.push(`/step-detail?${qs}`);
    } catch (e) {
      console.error(e);
    }
  }, []);

  return <li className={"fib-process-markers mb-3"}
             style={{cursor: "pointer"}}
             onClick={() => onClickProcessV2(poz)}
  >

    <h6>{translate(langData.localize, poz.process_manufacturer_name)}</h6>

    <div className="d-flex flex-row align-items-center">

       <span
         className={`fib-process-markers-status process-status-${(poz.claimed_status || "").toLowerCase()}`}
         dangerouslySetInnerHTML={{__html: poz.custom_order}}/>

      <span
        className={`fib-process-markers-pname  ml-2`}
        dangerouslySetInnerHTML={
          {__html: poz.process_name}
        }/>

      {/*<ProcessClaimStatusBadge claimed_status={poz.claimed_status} className={"ml-3"}/>*/}

      <VerificationLegendBadge poz={poz} status={(poz.claimed_status?.toLocaleUpperCase())} className={"ml-3"}/>

    </div>

    <VerifiedLabelMarkup className={"mt-1 mb-1"} poz={poz}/>

  </li>
}

export default ContentMarkerMultiple;
